export default __webpack_public_path__ + "static/media/oamlogo.e46e3b5a.svg";